"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _imageLoader = _interopRequireDefault(require("../image-loader"));
require("./card.css");
var _excluded = ["imagePosition", "imageSize", "containerClasses", "disableBoxShadow", "contentClasses", "imageUrl", "imageChild", "imageAlt", "imageFit", "imageFitPosition", "imageClasses", "imageLoaderProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Wraps provided children in a styled box which we call a Card.
 *
 * Card will style an image in one of three imagePositions (top, left, right) if an imageUrl
 * is provided.
 *
 * Padding (if needed) must be explicitly declared using a padding utility class: containerClasses
 * for Card, contentClasses for any children, and imageClasses.
 */
var Card = exports["default"] = /*#__PURE__*/function (_Component) {
  function Card() {
    _classCallCheck(this, Card);
    return _callSuper(this, Card, arguments);
  }
  _inherits(Card, _Component);
  return _createClass(Card, [{
    key: "renderImage",
    value: function renderImage() {
      var _this$props = this.props,
        imageUrl = _this$props.imageUrl,
        imageChild = _this$props.imageChild,
        imageAlt = _this$props.imageAlt,
        imagePosition = _this$props.imagePosition,
        imageClasses = _this$props.imageClasses,
        imageSize = _this$props.imageSize,
        imageFit = _this$props.imageFit,
        imageFitPosition = _this$props.imageFitPosition,
        imageLoaderProps = _this$props.imageLoaderProps;
      var styles = {};
      var imageBlockClassList = (0, _classnames["default"])(_defineProperty({
        'sb-card__imageBlockLeft': imagePosition === 'left',
        'sb-card__imageBlockRight': imagePosition === 'right',
        'sb-card__imageBlockSmall': Boolean(imageSize === 'sm')
      }, imageClasses, Boolean(imageClasses)));
      if (!imageUrl && !imageChild) {
        return null;
      }
      if (imageFit !== 'contain' || imageFitPosition !== 'center') {
        styles.objectFit = imageFit;
        styles.objectPosition = imageFitPosition;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: imageBlockClassList
      }, imageChild || /*#__PURE__*/_react["default"].createElement(_imageLoader["default"], _extends({
        alt: imageAlt,
        className: "sb-card__image",
        src: imageUrl,
        style: styles
      }, imageLoaderProps)));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        contentClasses = _this$props2.contentClasses;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('sb-card__content', _defineProperty({}, "".concat(contentClasses), Boolean(contentClasses)))
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        imagePosition = _this$props3.imagePosition,
        imageSize = _this$props3.imageSize,
        containerClasses = _this$props3.containerClasses,
        disableBoxShadow = _this$props3.disableBoxShadow,
        contentClasses = _this$props3.contentClasses,
        imageUrl = _this$props3.imageUrl,
        imageChild = _this$props3.imageChild,
        imageAlt = _this$props3.imageAlt,
        imageFit = _this$props3.imageFit,
        imageFitPosition = _this$props3.imageFitPosition,
        imageClasses = _this$props3.imageClasses,
        imageLoaderProps = _this$props3.imageLoaderProps,
        otherProps = _objectWithoutProperties(_this$props3, _excluded);
      var cardShadow = disableBoxShadow ? '' : 'sb-card-shadow';
      var containerClassList = (0, _classnames["default"])("sb-card ".concat(cardShadow), _defineProperty({
        'sb-card--imageLeft': imagePosition === 'left',
        'sb-card--imageRight': imagePosition === 'right',
        'sb-card--imageSmall': Boolean(imageSize === 'sm')
      }, containerClasses, Boolean(containerClasses)));
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: containerClassList
      }, otherProps), this.renderImage(), this.renderContent());
    }
  }]);
}(_react.Component);
Card.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  imageAlt: _propTypes["default"].string,
  imagePosition: _propTypes["default"].oneOf(['top', 'left', 'right']),
  imageUrl: _propTypes["default"].string,
  /**
   * If you require sending down a separate image, rather than a URL,
   * send it down with `imageChild`. Be warned that while you retain
   * the styling of the image's parent, you lose some of the flex
   * styling already applied to an image when you send in `imageUrl` only.
   */
  imageChild: _propTypes["default"].object,
  /**
   * If sm is selected, the card's image will be smaller, and will not be reverted to the top of
   * the card on small devices.
   */
  imageSize: _propTypes["default"].oneOf(['sm', 'default']),
  /**
   * Overrides the default object-fit of 'contain'. For further information about this CSS property,
   * refer to https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
   */
  imageFit: _propTypes["default"].oneOf(['contain', 'cover', 'none', 'fill', 'scale-down']),
  /**
   * Overrides the default object-position of 'center'. For further information about this CSS property,
   * refer to https://developer.mozilla.org/en-US/docs/Web/CSS/object-position
   * Invalid strings will be ignored by the browser.
   */
  imageFitPosition: _propTypes["default"].string,
  /**
   * Optional class(es) that will be applied to the image.
   * For example the horizontal width of the image can be specified by the consumer.
   */
  imageClasses: _propTypes["default"].string,
  /**
   * Optional class(es) that are applied to the top level element,
   * which is the entirety of the card.
   */
  containerClasses: _propTypes["default"].string,
  /**
   * Optional class(es). Applies to the non-image portion of the content.
   */
  contentClasses: _propTypes["default"].string,
  /**
   * Allows card to be rendered without the card shadow.
   */
  disableBoxShadow: _propTypes["default"].bool,
  /**
   * Props that are passed to the `ImageLoader` component. Refer to the [ImageLoader](/components/images) documentation for more details on these props.
   */
  imageLoaderProps: _propTypes["default"].object
} : {};
Card.defaultProps = {
  imageAlt: '',
  imageSize: 'default',
  imageFit: 'contain',
  imageFitPosition: 'center',
  disableBoxShadow: false,
  imageLoaderProps: {}
};